import { render, staticRenderFns } from "./StepFile.vue?vue&type=template&id=2b76b30a&scoped=true&"
import script from "./StepFile.vue?vue&type=script&lang=js&"
export * from "./StepFile.vue?vue&type=script&lang=js&"
import style0 from "./StepFile.vue?vue&type=style&index=0&id=2b76b30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76b30a",
  null
  
)

export default component.exports